var impressum = "Impressum";
var privacy = "Privatnost i pravna pitanja";
var recallInfo = "Informacije o povratu";
var signOut = "Odjava";
var hr_hr = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { hr_hr as default, impressum, privacy, recallInfo, signOut };
